import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { FieldForm } from '../../entities/forms/field-form';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class FieldFormService {
  // Define API
  
  apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // HttpClient API get() method => Fetch forms list
  getFieldForms(): Observable<FieldForm> {
    return this.http.get<FieldForm>(this.apiURL + '/getformulariocampo')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API get() method => Fetch form
  getFieldForm(formId): Observable<FieldForm> {
    return this.http.post<FieldForm>(this.apiURL + '/getformularioid', JSON.stringify(formId), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API post() method => Creando Campo
  // tslint:disable-next-line: no-shadowed-variable
  createFieldForm(fieldForm): Observable<FieldForm> {
    return this.http.post<FieldForm>(this.apiURL + '/formulario_campo/0', JSON.stringify(fieldForm), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API put() method => Update form
  updateFieldForm(id, fieldForm): Observable<FieldForm> {
    return this.http.put<FieldForm>(this.apiURL + '/formulario_campo/' + id, JSON.stringify(fieldForm), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API delete() method => Delete form
  deleteFieldForm(id) {
    return this.http.delete<FieldForm>(this.apiURL + '/formulario_campo/' + id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }


 createOption(option){
  return this.http.post(this.apiURL + '/formulario_campo_opcion/0', JSON.stringify(option), this.httpOptions)
  .pipe(
    retry(1),
    catchError(this.handleError)
  );
 }

getOptions(id){
  return this.http.get(this.apiURL + '/getformulariocampoopcionParm?formulario_campo_id=' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
}

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code (Campo): ${error.status}\nMessage (Campo): ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}

